export default __webpack_public_path__ + "static/logo dasco-f73610c5c2ab982566f3846f6e5eb056.jpg";